/* global Office */

import * as amplitude from '@amplitude/analytics-browser'

export interface ExcelClientInfo {
    host: string
    platform: string
    version: string
    majorVersion: string
    displayLanguage: string
    touchEnabled: boolean
    screenWidth: number
    screenHeight: number
    isMac: boolean
    isWindows: boolean
    isWeb: boolean
}

export function getExcelClientInfo(): ExcelClientInfo {
    const diagnostics = Office.context.diagnostics
    const platform = diagnostics?.platform?.toString() || 'unknown'
    const version = diagnostics?.version || 'unknown'

    return {
        host: diagnostics?.host?.toString() || 'unknown',
        platform,
        version,
        majorVersion: parseOfficeMajorVersion(version),
        displayLanguage: Office.context.displayLanguage || 'unknown',
        touchEnabled: Office.context.touchEnabled ?? false,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        isMac: platform === 'Mac',
        isWindows: platform === 'PC',
        isWeb: platform === 'OfficeOnline',
    }
}

function parseOfficeMajorVersion(version: string): string {
    if (!version || version === 'unknown') return 'unknown'
    const parts = version.split('.')
    if (parts.length >= 2) {
        return `${parts[0]}.${parts[1]}`
    }
    return version
}

export function setExcelClientUserProperties(): void {
    const clientInfo = getExcelClientInfo()

    const identify = new amplitude.Identify()
    identify.set('office_host', clientInfo.host)
    identify.set('office_platform', clientInfo.platform)
    identify.set('office_version', clientInfo.version)
    identify.set('office_major_version', clientInfo.majorVersion)
    identify.set('display_language', clientInfo.displayLanguage)
    identify.set('touch_enabled', clientInfo.touchEnabled)
    identify.set('screen_width', clientInfo.screenWidth)
    identify.set('screen_height', clientInfo.screenHeight)
    identify.set('is_mac', clientInfo.isMac)
    identify.set('is_windows', clientInfo.isWindows)
    identify.set('is_web', clientInfo.isWeb)

    amplitude.identify(identify)
}
